import { Component, OnInit } from '@angular/core';
import { FormGroup, Validators, FormControl } from '@angular/forms';
import { LiftBoardParameterDetail } from '../../models/lift-board-parameter-detail.model';
import { ActivatedRoute } from '@angular/router';
import { LoginService } from '../../../user/services/login.service';
import { LiftBoardParameterService } from '../../services/lift-board-parameter.service';
import { EntityListRefresh } from '../../../core/services/entity-list.refresh';
import { UINotificationService } from '../../../core/services/ui-notification.service';
import { ModalComponent } from '../../../core/components/modal/modal.component';
import { NotificationType } from '../../../core/models/ui-notification.model';

@Component({
  selector: 'app-lift-board-parameter-group-detail',
  templateUrl: './lift-board-parameter-group-detail.component.html',
  styleUrls: ['./lift-board-parameter-group-detail.component.css']
})
export class LiftBoardParameterGroupDetailComponent implements OnInit {
  form = new FormGroup({});
  boardGroup: LiftBoardParameterDetail;

  constructor(
    private route: ActivatedRoute,
    private loginService: LoginService,
    private liftBoardParameterService: LiftBoardParameterService,
    private entityListRefresh: EntityListRefresh,
    private uiNotificationService: UINotificationService
  ) { }

  ngOnInit() {
    this.boardGroup = this.route.snapshot.data.liftBoardParameterGroup;
    this.form.addControl('title', new FormControl(this.boardGroup.language[0].title, Validators.required));
  }

  close(modal: ModalComponent) {
    modal.closeModal(null);
  }

  onSubmit(modal: ModalComponent) {
    if (this.form.valid) {
      const lookupLang = [
        { twoLetterISOLanguageName: 'cs', title: this.form.get('title').value, description: this.form.get('title').value },
        { twoLetterISOLanguageName: 'de', title: this.form.get('title').value, description: this.form.get('title').value },
        { twoLetterISOLanguageName: 'en', title: this.form.get('title').value, description: this.form.get('title').value }
      ];

      this.liftBoardParameterService.update({
        id: this.boardGroup.id,
        liftBoardId: this.boardGroup.liftBoardId,
        parentId: null,
        liftParameterId: null,
        values: null,
        language: lookupLang
      }).subscribe(() => {
        this.entityListRefresh.refresh('lift-board-parameter');
        this.uiNotificationService.add({
          type: NotificationType.Info,
          message: 'Skupina bylaaktualizována'
        });
        modal.closeModal(null);
      });
    }
  }

}
